(function ($, document, window) {
    'use strict';

    $(function () {
        const $carousel = $('.js-featured-publications-carousel');
        const draggingClass = 'is-dragging';


        $carousel.each(function () {
            const $this = $(this);
            const $container = $this.closest('.js-featured-publications-container');
            const pagination = $container.find('.js-featured-publications-carousel-pagination').toArray();
            const prevEl = $container.find('.js-featured-publications-carousel-nav-prev').toArray();
            const nextEl = $container.find('.js-featured-publications-carousel-nav-next').toArray();

            const swiper = new Swiper(this, {
                direction: 'horizontal',
                slidesPerView: 'auto',
                spaceBetween: 24,
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20,
                mobileFirst: true,
                grabCursor: true,
                speed: 800,

                pagination: {
                    el: pagination,
                    type: 'progressbar',
                },

                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl,
                },

                breakpoints: {
                    768: {
                        spaceBetween: 24,
                        slidesPerGroup: 2,
                    },

                    1024: {
                        spaceBetween: 30,
                        slidesPerGroup: 4,
                        slidesOffsetBefore: 30,
                        slidesOffsetAfter: 30,
                    },

                    1400: {
                        spaceBetween: 30,
                        slidesPerGroup: 4,
                        slidesOffsetBefore: 60,
                        slidesOffsetAfter: 60,
                    },

                    1520: {
                        spaceBetween: 30,
                        slidesPerGroup: 4,
                        slidesOffsetBefore: function () {
                            return ($(window).outerWidth() - $container.width()) / 2;
                        },
                        slidesOffsetAfter: function () {
                            return ($(window).outerWidth() - $container.width()) / 2;
                        },
                    },
                },

                on: {
                    touchStart: function () {
                        $carousel.addClass(draggingClass);
                    },

                    touchEnd: function () {
                        $carousel.removeClass(draggingClass);
                    },
                },
            })
        });
    });
})(jQuery, document, window);
